import Content from './privacy-policy.mdx'
import { mdxComponents } from '../components/MdxComponents'
import { Header } from '../components/Header'
import Head from 'expo-router/head'
import React from 'react'
import { getSiteUrl } from '@/utils/getSiteUrl'

export const unstable_settings = {
  // This component will be rendered at build-time and never re-rendered in production.
  render: 'static',
}

export default function PrivacyPolicy() {
  const pageUrl = `${getSiteUrl()}/privacy-policy`

  return (
    <>
      <Head>
        <title>Privacy Policy - React Native Google Sign In</title>
        <meta name="description" content="Privacy policy for React Native Google Sign In package. Learn how we handle your data and protect your privacy." />
        <meta property="og:title" content="Privacy Policy - React Native Google Sign In" />
        <meta property="og:description" content="Privacy policy for React Native Google Sign In package." />
        <meta property="og:url" content={pageUrl} />
        <link rel="canonical" href={pageUrl} />
      </Head>
      <div className="h-full">
        <Header />
        <div className="p-4 max-w-3xl mx-auto">
          <Content components={mdxComponents} />
        </div>
      </div>
    </>
  )
}
